// BLACKOUT SCRIPTS — theme v3 client behavior (kept intentionally light)
// Everything lives inside one IIFE: nothing here defines a global.

(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── Tier picker: highlight selected radio in PDP ──────────────────────────
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.name !== 'id') return;
    var group = input.closest('.pdp-tiers');
    if (!group) return;
    var tiers = group.querySelectorAll('.tier');
    for (var i = 0; i < tiers.length; i++) tiers[i].classList.remove('active');
    var t = input.closest('.tier');
    if (t) t.classList.add('active');
  });

  // ── Add-to-cart ───────────────────────────────────────────────────────────
  // Scoped to the theme's own product form so app-injected forms (upsells,
  // quick-add, bundles) keep their native behaviour.
  (function () {
    var busy = false;
    // Set while a request is in flight, so a bfcache restore can undo the
    // loading state. See the pageshow handler below.
    var pendingRestore = null;

    function buttonsFor(form) {
      var out = [];
      // includes the sticky mobile bar's button, which sits outside the form
      // and is associated via form="product-form".
      var all = document.querySelectorAll('button[name="add"]');
      for (var i = 0; i < all.length; i++) {
        if (all[i].form === form) out.push(all[i]);
      }
      return out;
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      // NB: `form.id` is unusable here. HTMLFormElement exposes its controls as
      // named properties that override built-ins, and the variant radios are
      // name="id" — so `form.id` returns a RadioNodeList, not the string.
      // matches() reads the real attribute.
      if (!form || !form.matches || !form.matches('#product-form')) return;

      // A second submit while the first is in flight would add a second line
      // item. Swallow it.
      if (busy) { e.preventDefault(); return; }

      e.preventDefault();
      busy = true;

      var btns = buttonsFor(form);
      var errEl = form.querySelector('.pdp-error');
      var labels = [];
      var wasDisabled = [];

      for (var i = 0; i < btns.length; i++) {
        labels.push(btns[i].innerHTML);
        wasDisabled.push(btns[i].disabled);
        var loading = btns[i].getAttribute('data-loading-label');
        if (loading) btns[i].textContent = loading;
        btns[i].disabled = true;
      }
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }

      function restore() {
        for (var j = 0; j < btns.length; j++) {
          btns[j].disabled = wasDisabled[j];
          btns[j].innerHTML = labels[j];
        }
        pendingRestore = null;
        busy = false;
      }
      pendingRestore = restore;

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) {
          // /cart/add.js answers 422 with a JSON error body on sold-out,
          // inventory and line-limit failures. r.json() resolves happily on
          // that body, so the status has to be checked explicitly.
          if (!r.ok) {
            return r.json()
              .catch(function () { return {}; })
              .then(function (j) {
                var err = new Error(j.description || j.message || 'Could not add this to your cart.');
                err.shown = true;
                throw err;
              });
          }
          return r.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          var c = document.getElementById('cart-count');
          if (c) c.textContent = cart.item_count;
          window.location.href = '/cart';  // leave the buttons disabled: navigating
        })
        .catch(function (err) {
          restore();
          if (err && err.shown) {
            if (errEl) {
              errEl.textContent = err.message;
              errEl.hidden = false;
            } else {
              form.submit();
            }
            return;
          }
          // Network / parse failure — fall back to the native POST so the
          // customer still reaches Shopify's own handling.
          form.submit();
        });
    });

    // On success the buttons are left disabled on purpose while the browser
    // navigates to /cart. Pressing Back can hand this very page back from the
    // bfcache with that state frozen in — busy still true, both buy buttons
    // dead. Undo it whenever the page is restored rather than reloaded.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && pendingRestore) pendingRestore();
    });
  })();

  // ── PDP: thumbnail strip swaps the main image ────────────────────────────
  (function () {
    var strip = document.querySelector('.pdp-thumbs');
    var main = document.querySelector('.pdp-art');
    if (!strip || !main) return;

    strip.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.pdp-thumb-btn') : null;
      if (!btn || !strip.contains(btn)) return;
      var src = btn.getAttribute('data-src');
      if (!src) return;

      main.src = src;
      var srcset = btn.getAttribute('data-srcset');
      if (srcset) { main.srcset = srcset; } else { main.removeAttribute('srcset'); }

      var all = strip.querySelectorAll('.pdp-thumb-btn');
      for (var i = 0; i < all.length; i++) {
        all[i].setAttribute('aria-pressed', all[i] === btn ? 'true' : 'false');
      }
    });
  })();

  // ── Mobile menu ───────────────────────────────────────────────────────────
  (function () {
    var burger = document.getElementById('nav-burger');
    var menu = document.getElementById('mobile-menu');
    if (!burger || !menu) return;

    var openLabel = burger.getAttribute('data-label-open') || 'Open menu';
    var closeLabel = burger.getAttribute('data-label-close') || 'Close menu';

    function setState(open) {
      menu.classList.toggle('open', open);
      burger.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? closeLabel : openLabel);
      document.body.classList.toggle('menu-open', open);
    }

    burger.addEventListener('click', function () {
      setState(!menu.classList.contains('open'));
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) setState(false);
    });
  })();

  // ── Nav: hairline border once scrolled ────────────────────────────────────
  (function () {
    var nav = document.querySelector('.nav');
    if (!nav) return;
    var on = false;
    function check() {
      var s = window.scrollY > 8;
      if (s !== on) { on = s; nav.classList.toggle('scrolled', s); }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  })();

  // ── Scroll-reveal: single subtle fade-up ──────────────────────────────────
  (function () {
    var els = document.querySelectorAll('.feature, .product, .review, .help-card, .rs-stat, .how-step, .showcase, .compare-card, .cta-card, .sec-head');
    if (!els.length) return;
    if (REDUCED || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('rv', 'in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px' });
    els.forEach(function (el, i) {
      el.classList.add('rv');
      el.style.transitionDelay = ((i % 3) * 60) + 'ms';
      io.observe(el);
    });
  })();

  // ── Announcement bar: dismiss persists until the message changes ──────────
  (function () {
    var bar = document.getElementById('announce');
    if (!bar) return;
    var KEY = 'bo-announce-dismissed';
    var msg = (bar.textContent || '').replace(/\s+/g, ' ').trim();
    try {
      if (localStorage.getItem(KEY) === msg) { bar.classList.add('hidden'); return; }
    } catch (e) {}
    var x = bar.querySelector('.announce-x');
    if (x) x.addEventListener('click', function () {
      bar.classList.add('hidden');
      try { localStorage.setItem(KEY, msg); } catch (e) {}
    });
  })();

  // ── FAQ: smooth open/close ────────────────────────────────────────────────
  (function () {
    if (REDUCED) return;
    document.querySelectorAll('.faq-item').forEach(function (item) {
      var summary = item.querySelector('summary');
      var body = item.querySelector('.faq-body');
      if (!summary || !body) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.classList.contains('animating')) return;
        item.classList.add('animating');
        if (item.open) {
          var h0 = body.scrollHeight;
          body.style.height = h0 + 'px';
          requestAnimationFrame(function () {
            body.style.transition = 'height .28s cubic-bezier(.25,.6,.3,1), opacity .2s';
            body.style.height = '0px'; body.style.opacity = '0';
            setTimeout(function () {
              item.open = false;
              body.style.cssText = '';
              item.classList.remove('animating');
            }, 300);
          });
        } else {
          item.open = true;
          var h1 = body.scrollHeight;
          body.style.height = '0px'; body.style.opacity = '0';
          requestAnimationFrame(function () {
            body.style.transition = 'height .3s cubic-bezier(.25,.6,.3,1), opacity .25s .05s';
            body.style.height = h1 + 'px'; body.style.opacity = '1';
            setTimeout(function () {
              body.style.cssText = '';
              item.classList.remove('animating');
            }, 340);
          });
        }
      });
    });
  })();

  // ── Reviews: real data from the dashboard feed ────────────────────────────
  // GET {endpoint} -> { aggregate: { average, count }, reviews: [ … ] }
  //
  // Two consumers share one memoised request per URL: the aggregate binders
  // (product page rating, showcase rating line) and the live wall. Everything
  // here is progressive enhancement — every consumer is already server-rendered
  // with merchant-editable content, so a failed, slow or empty response simply
  // leaves that content in place. Nothing invents a number or a sentence.
  //
  // Review text is submitted by customers. It is written with textContent and
  // built with createElement only; innerHTML is never used with feed data.
  (function () {
    if (!window.fetch) return;                  // static fallback stands

    var TIMEOUT = 6000;
    // Defensive re-clamps, sized to the server's own caps so a real review is
    // never cut: the review modal accepts 500 characters, so anything under
    // that is the customer's whole sentence and gets shown whole. These only
    // bite if the feed ever hands back something longer than it promises.
    var BODY_MAX = 500;
    var NAME_MAX = 40;
    var TAG_MAX = 80;
    var cache = {};                             // url -> Promise

    function get(url) {
      if (cache[url]) return cache[url];
      var ctl = null, timer = null;
      var opts = {};
      if (typeof AbortController !== 'undefined') {
        ctl = new AbortController();
        opts.signal = ctl.signal;
        timer = setTimeout(function () { ctl.abort(); }, TIMEOUT);
      }
      cache[url] = fetch(url, opts)
        .then(function (r) {
          if (!r.ok) throw new Error('feed ' + r.status);
          return r.json();
        })
        .then(function (d) {
          if (!d || typeof d !== 'object' || d.error) throw new Error('feed payload');
          return d;
        })
        .catch(function (e) { return null; })   // one shape for every failure
        .then(function (d) {
          if (timer) clearTimeout(timer);
          return d;
        });
      return cache[url];
    }

    function clamp(v, max) {
      if (typeof v !== 'string') return '';
      v = v.replace(/\s+/g, ' ').trim();
      return v.length > max ? v.slice(0, max) : v;
    }

    function starCount(n) {
      n = Math.round(Number(n));
      if (!isFinite(n)) return 0;
      return Math.max(0, Math.min(5, n));
    }

    function starGlyphs(n) {
      var out = '';
      for (var i = 0; i < n; i++) out += '★';
      return out;
    }

    // <span class="r-stars" role="img" aria-label="…"><span aria-hidden>★★★★★</span></span>
    function starsEl(value, cls) {
      var n = starCount(value);
      var wrap = document.createElement('span');
      wrap.className = cls || 'r-stars';
      wrap.setAttribute('role', 'img');
      wrap.setAttribute('aria-label', value + ' out of 5 stars');
      var glyphs = document.createElement('span');
      glyphs.setAttribute('aria-hidden', 'true');
      glyphs.textContent = starGlyphs(n);
      wrap.appendChild(glyphs);
      return wrap;
    }

    function fill(tpl, rating, count) {
      return String(tpl).replace(/\{rating\}/g, rating).replace(/\{count\}/g, count);
    }

    // ── aggregate: score + stars + count, wherever it is marked up ──────────
    function applyAggregate(el, d) {
      if (!el) return;
      var agg = d && d.aggregate;
      if (!agg) return;                         // keep whatever was rendered
      var avg = Number(agg.average);
      var count = Number(agg.count);
      if (!isFinite(avg) || !isFinite(count) || count < 1 || avg < 1) return;
      var rating = (Math.round(avg * 10) / 10).toString();

      var stars = el.querySelector('[data-bo-agg-stars]');
      if (stars) {
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', rating + ' out of 5 stars');
        var glyphs = stars.querySelector('[aria-hidden="true"]');
        if (!glyphs) {
          glyphs = document.createElement('span');
          glyphs.setAttribute('aria-hidden', 'true');
          stars.appendChild(glyphs);
        }
        glyphs.textContent = starGlyphs(starCount(avg));
      }

      var meta = el.querySelector('[data-bo-agg-meta]');
      if (meta) {
        var tpl = count === 1
          ? (meta.getAttribute('data-bo-tpl-one') || meta.getAttribute('data-bo-tpl'))
          : meta.getAttribute('data-bo-tpl');
        if (tpl) meta.textContent = fill(tpl, rating, count);
      }
      el.hidden = false;                        // may have been held back
      el.removeAttribute('data-bo-pending');
    }

    function bindAggregate(el) {
      var src = el.getAttribute('data-bo-src');
      if (!src) return;
      // An aggregate inside a live wall is filled from that wall's own
      // response instead, so the page makes one request, not two.
      if (el.closest && el.closest('[data-bo-reviews][data-bo-src]')) return;
      get(src).then(function (d) { applyAggregate(el, d); });
    }

    // ── live wall ───────────────────────────────────────────────────────────
    function card(r, opts) {
      var art = document.createElement('article');
      art.className = 'review';

      art.appendChild(starsEl(starCount(r.stars), 'r-stars'));

      var body = clamp(r.body, BODY_MAX);
      if (body) {
        var p = document.createElement('p');
        p.className = 'r-body';
        p.textContent = body;                   // never innerHTML
        art.appendChild(p);
      } else {
        var spacer = document.createElement('div');
        spacer.className = 'r-spacer';
        spacer.setAttribute('aria-hidden', 'true');
        art.appendChild(spacer);
      }

      var name = clamp(r.name, NAME_MAX) || opts.anon;
      var meta = document.createElement('div');
      meta.className = 'r-meta';

      var avatar = document.createElement('div');
      avatar.className = 'r-avatar';
      avatar.setAttribute('aria-hidden', 'true');
      if (opts.avatar) avatar.style.background = opts.avatar;
      avatar.textContent = name.charAt(0).toUpperCase();
      meta.appendChild(avatar);

      var who = document.createElement('div');
      var nameEl = document.createElement('div');
      nameEl.className = 'r-name';
      nameEl.textContent = name;
      who.appendChild(nameEl);

      var tag = document.createElement('div');
      tag.className = 'r-tag';
      var product = clamp(r.product, TAG_MAX);
      if (product) tag.appendChild(document.createTextNode(product));
      var when = date(r.created_at);
      if (when) {
        if (tag.firstChild) tag.appendChild(document.createTextNode(' · '));
        tag.appendChild(document.createTextNode(when));
      }
      if (r.verified && opts.verified) {
        if (tag.firstChild) tag.appendChild(document.createTextNode(' · '));
        var v = document.createElement('span');
        v.className = 'verified';
        v.textContent = opts.verified;
        tag.appendChild(v);
      }
      if (tag.firstChild) who.appendChild(tag);

      meta.appendChild(who);
      art.appendChild(meta);
      return art;
    }

    function date(iso) {
      if (!iso) return '';
      var d = new Date(iso);
      if (isNaN(d.getTime())) return '';
      try {
        return d.toLocaleDateString(undefined, { month: 'short', year: 'numeric' });
      } catch (e) {
        return '';
      }
    }

    function wall(root) {
      var src = root.getAttribute('data-bo-src');
      var grid = root.querySelector('[data-bo-grid]');
      if (!src || !grid) return;                // live off, or nothing to fill

      var want = parseInt(root.getAttribute('data-bo-count'), 10);
      if (!isFinite(want) || want < 1) want = 6;
      var status = root.querySelector('[data-bo-status]');
      var loading = root.getAttribute('data-bo-loading-text');
      var hadFallback = grid.children.length > 0;
      var editor = !!(window.Shopify && window.Shopify.designMode);

      if (status && loading) {
        status.textContent = loading;
        status.hidden = false;
      }
      grid.classList.add('is-loading');
      grid.setAttribute('aria-busy', 'true');

      // The feed returns the newest rows whether or not they carry text; ask
      // for headroom so a run of star-only ratings still fills the grid.
      var limit = Math.min(50, Math.max(want, want * 3));
      var url = src + (src.indexOf('?') > -1 ? '&' : '?') + 'limit=' + limit;

      get(url).then(function (d) {
        grid.classList.remove('is-loading');
        grid.setAttribute('aria-busy', 'false');
        if (status) status.hidden = true;
        applyAggregate(root.querySelector('[data-bo-aggregate]'), d);

        var list = (d && d.reviews && d.reviews.length) ? d.reviews : [];
        var opts = {
          avatar: root.getAttribute('data-bo-avatar') || '',
          verified: root.getAttribute('data-bo-verified-text') || '',
          anon: root.getAttribute('data-bo-anon-text') || 'Verified buyer'
        };
        var cards = [];
        for (var i = 0; i < list.length && cards.length < want; i++) {
          var r = list[i];
          // Star-only ratings count towards the aggregate the endpoint
          // computes, but a card with no words has nothing to say.
          if (!r || !clamp(r.body, BODY_MAX) || !starCount(r.stars)) continue;
          cards.push(card(r, opts));
        }

        if (cards.length) {
          grid.textContent = '';                // drop the fallback blocks
          for (var c = 0; c < cards.length; c++) grid.appendChild(cards[c]);
          reveal(grid);
          // A section with no fallback blocks ships hidden so it can never be
          // an empty shell; real cards are what earns it a place on the page.
          root.hidden = false;
          return;
        }

        // Nothing live to show. The merchant's own blocks are the fallback;
        // with none of those either, show nothing rather than an empty shell.
        if (hadFallback) return;
        var empty = root.getAttribute('data-bo-empty-text');
        if (editor && empty && status) {
          status.textContent = empty;
          status.hidden = false;
          return;
        }
        root.hidden = true;
      });
    }

    // Cards built after the reveal observer has run would stay invisible.
    function reveal(grid) {
      var kids = grid.children;
      for (var i = 0; i < kids.length; i++) kids[i].classList.add('rv', 'in');
    }

    function bindAll(scope) {
      var agg = scope.querySelectorAll('[data-bo-aggregate]');
      for (var a = 0; a < agg.length; a++) bindAggregate(agg[a]);
      var walls = scope.querySelectorAll('[data-bo-reviews]');
      for (var w = 0; w < walls.length; w++) wall(walls[w]);
    }

    bindAll(document);

    // The editor re-renders a section from the server on every settings
    // change, which puts the fallback blocks back. Re-bind so the merchant
    // keeps seeing the live cards; the response is already cached.
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        if (e.target && e.target.querySelectorAll) bindAll(e.target);
      });
    }
  })();

  // ── PDP: sticky mobile buy bar ────────────────────────────────────────────
  (function () {
    var bar = document.getElementById('pdp-bar');
    var buyBtn = document.querySelector('.pdp-buy');
    if (!bar || !buyBtn) return;
    document.body.classList.add('has-pdp-bar');
    // show the bar once the in-page buy button is mostly out of view above
    var ticking = false;
    function check() {
      ticking = false;
      var r = buyBtn.getBoundingClientRect();
      bar.classList.toggle('show', r.bottom < 24);
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(check); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();
    // keep the bar's price in sync with the selected tier
    var priceEl = document.getElementById('pdp-bar-price');
    document.addEventListener('change', function (e) {
      if (e.target.name === 'id' && e.target.closest('.pdp-tiers')) {
        var tier = e.target.closest('.tier');
        var p = tier && tier.querySelector('.tier-price');
        if (p && priceEl) priceEl.textContent = p.textContent.trim();
      }
    });
  })();
})();
